// src/components/tools/PlaceholderAdmin.jsx
import React from 'react';
import './PlaceholderAdmin.css';

export default function PlaceholderAdmin({ tool, onBack }) {
    return (
        <div className="tool-details">
            {/* Der Zurück-Button */}
            <button className="back-btn" onClick={onBack}>← Zurück</button>

            {/* Header */}
            <div style={{textAlign: 'center', marginTop: '50px'}}>
                <div style={{fontSize: '60px', marginBottom: '20px'}}>🚧</div>
                <h3>{tool.tool_name}</h3>
                <p style={{color: '#666', maxWidth: '400px', margin: '0 auto'}}>
                    Dieses Modul ist noch in Entwicklung. 
                    <br />
                    Hier entsteht bald die Verwaltung für <strong>{tool.tool_name}</strong>.
                </p>
                
                <div style={{marginTop: '30px', padding: '20px', background: '#f9fafb', borderRadius: '8px', display: 'inline-block'}}>
                    <strong>Debug Info:</strong>
                    <br/>
                    Key: <code>{tool.tool_key}</code>
                    <br/>
                    ID: <code>{tool.id}</code>
                </div>
            </div>
        </div>
    );
}